import { render, staticRenderFns } from "./ItemSelector.vue?vue&type=template&id=527f058d"
import script from "./ItemSelector.vue?vue&type=script&lang=ts"
export * from "./ItemSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports